module.exports = __webpack_public_path__ + "res/31-img_bg_l.eaa4a3c65764a03a111cc07a28893450.png";